<template>
  <div>
    <h1>Client cards</h1>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      loading: true,
      project: null,
      client: null,
      clientId: this.$route.params.client_id,
      projectId: this.$route.params.project_id,
    };
  },
  mounted: function() {
    this.getProjectsAndClient();
  },
  methods: {
    getProjectsAndClient: function() {
      this.$store
        .dispatch("api/fetchProjects", this.clientId)
        .then(() => {
          this.projects = this.$store.getters["api/getProjects"];
        })
        .catch((err) => console.log(err));

      this.$store
        .dispatch("api/fetchClients", this.clientId)
        .then(() => {
          this.client = this.$store.getters["api/getClients"];
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
